// import Link from "next/link";
// import { useSelector } from "react-redux";
// import { useEffect, useState } from "react";
// import User from "../Offcanvas/User";
// import { useAppContext } from "@/context/Context";

// const HeaderRightTwo = ({ btnClass, btnText, userType }) => {
//   const { mobile, setMobile, search, setSearch, cartToggle, setCart } = useAppContext();
//   const { total_items } = useSelector((state) => state.CartReducer);

//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       const token = localStorage.getItem("token");
//       setIsLoggedIn(!!token);
//     }
//   }, []);

//   return (
//     <div className="header-right">
//       <ul className="quick-access">
//         <li className="access-icon">
//           <Link
//             className={`search-trigger-active rbt-round-btn ${search ? "" : "open"}`}
//             href="#"
//             onClick={() => setSearch(!search)}
//           >
//             <i className="feather-search"></i>
//           </Link>
//         </li>

//         <li className="access-icon rbt-mini-cart">
//           <Link
//             className="rbt-cart-sidenav-activation rbt-round-btn"
//             href="#"
//             onClick={() => setCart(!cartToggle)}
//           >
//             <i className="feather-shopping-cart"></i>
//             <span className="rbt-cart-count">{total_items}</span>
//           </Link>
//         </li>

//         {!isLoggedIn ? (
//           <li className="account-access rbt-user-wrapper">
//             <Link href="/login">Login</Link>
//           </li>
//         ) : (
//           <>
//             <li className="account-access rbt-user-wrapper d-none d-xl-block">
//               <Link href="#">
//                 <i className="feather-user"></i>
//                 {userType}
//               </Link>
//               <User />
//             </li>
//             <li className="access-icon rbt-user-wrapper d-block d-xl-none">
//               <Link className="rbt-round-btn" href="#">
//                 <i className="feather-user"></i>
//               </Link>
//               <User />
//             </li>
//           </>
//         )}
//       </ul>

//       <div className="rbt-btn-wrapper d-none d-xl-block">
//         <Link className={`rbt-btn ${btnClass}`} href="#">
//           <span data-text={btnText}>{btnText}</span>
//         </Link>
//       </div>

//       <div className="mobile-menu-bar d-block d-xl-none">
//         <div className="hamberger">
//           <button
//             className="hamberger-button rbt-round-btn"
//             onClick={() => setMobile(!mobile)}
//           >
//             <i className="feather-menu"></i>
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HeaderRightTwo;
import Link from "next/link";
import { useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import User from "../Offcanvas/User";
import { useAppContext } from "@/context/Context";

const HeaderRightTwo = ({ btnClass, btnText, userType }) => {
  const { mobile, setMobile, search, setSearch, cartToggle, setCart } = useAppContext();
  const { total_items } = useSelector((state) => state.CartReducer);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginDropdownOpen, setLoginDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const token = localStorage.getItem("token");
      setIsLoggedIn(!!token);
    }

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setLoginDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="header-right">
      <ul className="quick-access">
        <li className="access-icon">
          <Link
            className={`search-trigger-active rbt-round-btn ${search ? "" : "open"}`}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setSearch(!search);
            }}
          >
            <i className="feather-search"></i>
          </Link>
        </li>

        <li className="access-icon rbt-mini-cart">
          <Link
            className="rbt-cart-sidenav-activation rbt-round-btn"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setCart(!cartToggle);
            }}
          >
            <i className="feather-shopping-cart"></i>
            <span className="rbt-cart-count">{total_items}</span>
          </Link>
        </li>

        {!isLoggedIn ? (
          <li className="account-access rbt-user-wrapper" ref={dropdownRef} style={{ position: "relative" }}>
            <button
              onClick={() => setLoginDropdownOpen(!loginDropdownOpen)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#333",
                fontSize: "16px",
              }}
            >
              Login <i className="feather-chevron-down"></i>
            </button>
            {loginDropdownOpen && (
              <ul
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  background: "#fff",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  padding: "0.5rem 0",
                  listStyle: "none",
                  zIndex: 999,
                  minWidth: "160px",
                }}
              >
                <li>
                  <Link href="/login">
                    <span
                      style={{
                        display: "block",
                        padding: "0.5rem 1rem",
                        color: "#333",
                        fontSize: "16px"
                      }}
                    >
                      Student Login
                    </span>
                  </Link>
                </li>
                <li>
                  <Link href="/login?role=instructor">
                    <span
                      style={{
                        display: "block",
                        padding: "0.5rem 1rem",
                        color: "#333",
                        fontSize: "16px"
                      }}
                    >
                      Instructor Login
                    </span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
        ) : (
          <>
            <li className="account-access rbt-user-wrapper d-none d-xl-block">
              <Link href="#">
                <i className="feather-user"></i> {userType}
              </Link>
              <User />
            </li>
            <li className="access-icon rbt-user-wrapper d-block d-xl-none">
              <Link className="rbt-round-btn" href="#">
                <i className="feather-user"></i>
              </Link>
              <User />
            </li>
          </>
        )}
      </ul>

      <div className="rbt-btn-wrapper d-none d-xl-block">
        <Link className={`rbt-btn ${btnClass}`} href="#">
          <span data-text={btnText}>{btnText}</span>
        </Link>
      </div>

      <div className="mobile-menu-bar d-block d-xl-none">
        <div className="hamberger">
          <button
            className="hamberger-button rbt-round-btn"
            onClick={() => setMobile(!mobile)}
          >
            <i className="feather-menu"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeaderRightTwo;
